export default __webpack_public_path__ + "static/media/Version (6) - Ultimate Map_18.b72b313f.jpg";